import type { ReportAggregatesFilters, ReportOperationsFilters } from '@/api/models';

/** Count of active operations-list filters, for the `FiltersPopover` badge. Excludes pagination/sort. */
export function countActiveOperationsFilters(filters: ReportOperationsFilters): number {
  return [
    filters.dateFrom,
    filters.dateTo,
    filters.tenantCode?.length,
    filters.tenantTag?.length,
    filters.applicationCode?.length,
    filters.gateway?.length,
    filters.status?.length,
    filters.type?.length,
    filters.amountMin !== undefined ? 1 : undefined,
    filters.amountMax !== undefined ? 1 : undefined,
    filters.orderReference,
  ].filter((value) => Boolean(value)).length;
}

/** Count of active aggregates filters, for the `FiltersPopover` badge. */
export function countActiveAggregatesFilters(filters: ReportAggregatesFilters): number {
  return [
    filters.dateFrom,
    filters.dateTo,
    filters.tenantCode?.length,
    filters.tenantTag?.length,
    filters.applicationCode?.length,
    filters.gateway?.length,
  ].filter((value) => Boolean(value)).length;
}
